"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var creditCard = exports.creditCard = { "viewBox": "0 0 24 24", "children": [{ "name": "rect", "attribs": { "x": "1", "y": "4", "width": "22", "height": "16", "rx": "2", "ry": "2" }, "children": [] }, { "name": "line", "attribs": { "x1": "1", "y1": "10", "x2": "23", "y2": "10" }, "children": [] }], "attribs": { "fill": "none", "stroke": "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/feather/creditCard.js
// module id = 833
// module chunks = 1